import { Breadcrumbs, Card, Container, Flex } from '@teko/ds-desktop';
import {
  BlockHeader,
  NoProductsFound,
  ProductCarousel,
} from '@teko/teko-ecommerce';
import { LazyComponent } from 'components/LazyComponent';
import { NotFoundProductLayout } from 'components/ProductDetail/styles';
import { useProductDetailState, useTenantConfig } from 'contexts';
import { isServerless } from 'helpers';
import { t } from 'i18n';
import { FlashSalePromotionBlock } from 'modules/product-detail/shared/FlashSalePromotionBlock';
import { ProductInfo } from 'modules/product-detail/shared/NewLayoutComponents';
import { ReviewSection } from 'modules/product-detail/shared/ProductReview/ReviewSection';
import dynamic from 'next/dynamic';
import { Box } from 'reflexbox';
import { ProductDescription } from './NewProductDescription';
import { NewProductImages, ShareAndWishlist } from './new-components';

const FAQSection = dynamic(() =>
  import('components/FAQ').then((mod) => mod.FAQSection),
);

export const NewDetailPage = () => {
  const { product, breadcrumbs, relatedProducts } = useProductDetailState();
  const { epicOmni1550 } = useTenantConfig();

  if (!product) {
    return (
      <NotFoundProductLayout>
        <NoProductsFound show text={t('Không tìm thấy sản phẩm')} />
      </NotFoundProductLayout>
    );
  }

  const arrowStyle = {
    backgroundColor: 'white',
    borderRadius: 999,
    boxShadow: 'rgba(0, 0, 0, 0.2) 0px 5px 15px',
  };

  return (
    <Container marginBottom="s16">
      <Breadcrumbs breadcrumbs={breadcrumbs || []} />
      <Card padding="s12">
        <Flex align="start" gap="s24">
          <Box width="57.5%">
            <NewProductImages />
            <ShareAndWishlist />
            {/** seoInfo/shortDescription */}
          </Box>
          <Box width="calc(100% - 57.5%)">
            <FlashSalePromotionBlock />
            <Card marginBottom="s12">
              <ProductInfo />
            </Card>
          </Box>
        </Flex>
      </Card>
      <LazyComponent>
        <Flex gap="s16" marginTop="s16" align="start">
          <Box width="68.5%">
            <Card>
              <ProductDescription
                tabTitle={[t('Thông số kỹ thuật'), t('Chi tiết sản phẩm')]}
                buttonType="ghost"
              />
            </Card>
          </Box>
          <Box width="calc(100% - 68.5% - 16px)">
            <Card>Related news</Card>
            <Card marginTop="s16">Related videos</Card>
          </Box>
        </Flex>
      </LazyComponent>
      <LazyComponent>{epicOmni1550 && <ReviewSection />}</LazyComponent>
      {!!product.seoInfo?.faq && product.seoInfo.faq.length > 0 ? (
        <LazyComponent>
          <Card marginTop="s16">
            <FAQSection
              faq={product.seoInfo.faq}
              style={{ padding: '0px 16px' }}
            />
          </Card>
        </LazyComponent>
      ) : null}
      <LazyComponent>
        {relatedProducts.length ? (
          <Card marginTop="s16">
            <BlockHeader title={t('Sản phẩm liên quan')} />
            <ProductCarousel
              products={relatedProducts}
              productsPerRow={5}
              regionName="relatedProducts"
              virtual={isServerless()}
              customStyleLeftArrow={arrowStyle}
              customStyleRightArrow={arrowStyle}
            />
          </Card>
        ) : null}
      </LazyComponent>
    </Container>
  );
};
